import React, { FC } from 'react';
import styled from '@emotion/styled'
import { Box } from '@mui/material';
import { cssGlobals } from '../../app';

const StyledHeading = styled.h1`
  text-align: center;
  margin: 0 auto 50px;
`

export const Header: FC = () => {
  return <Box sx={{ width: cssGlobals.containerWidth, mx: 'auto', lineHeight: 1.5 }}>
    <StyledHeading>CBOR-LD Encoder/Decoder from JSON-LD document</StyledHeading>
    <p>This application takes a <a target="_blank" rel="noreferrer" href="https://www.w3.org/TR/json-ld11/">JSON-LD</a> document, validates its syntax, encodes it into <a target="_blank" rel="noreferrer" href="https://digitalbazaar.github.io/cbor-ld-spec/">CBOR-LD</a> according to the W3C specification. It also decodes from CBOR-LD to JSON-LD.</p>
    <span>This demo reuses the Javascript implementation provided by <a target="_blank" rel="noreferrer" href="https://github.com/digitalbazaar/cborld">Digital Bazaar available on Github</a>.</span>
  </Box>;
};
